import type { IconProps } from '../types';

const RightArrowSmall = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M19.1213 14.8738C19.7864 15.4772 19.7864 16.5226 19.1213 17.126L14.922 20.9359C13.9449 21.8223 12.3799 21.129 12.3799 19.8098V12.1901C12.3799 10.8708 13.9449 10.1775 14.922 11.064L19.1213 14.8738Z" />
  </svg>
);

export default RightArrowSmall;
